import { db } from '.';
import { performMoveInDB } from './utils';

async function addTopicToDB(data) {
  const newTopicRef = db.collection('topics').doc();
  await newTopicRef.set(data);
  return newTopicRef;
}

async function getTopicFromDB(uid) {
  const snapshot = await db
    .collection('topics')
    .doc(uid)
    .get();
  if (snapshot.exists) {
    return {
      ...snapshot.data(),
      id: snapshot.id
    };
  } else {
    throw new Error('No such topic!');
  }
}

async function updateTopicInDB(data) {
  const { id, ...docData } = data;
  await db
    .collection('topics')
    .doc(id)
    .update(docData);
}

async function moveConceptInDB(topicId, from, to) {
  const topicRef = db.collection('topics').doc(topicId);
  const conceptsRef = db
    .collection('concepts')
    .where('topicId', '==', topicRef);
  await performMoveInDB(conceptsRef, from, to);
}

async function moveTopicInDB(from, to) {
  const topicsRef = db.collection('topics');
  await performMoveInDB(topicsRef, from, to);
}

async function getTopicsFromDB(uids) {
  const topicFetchPromises = uids.map(uid => getTopicFromDB(uid));
  const topicSnaps = await Promise.all(topicFetchPromises);
  return topicSnaps;
}

export default {
  add: addTopicToDB,
  get: getTopicFromDB,
  move: moveTopicInDB,
  moveConcept: moveConceptInDB,
  update: updateTopicInDB,
  getAll: getTopicsFromDB
};
